import React from 'react';
import AppRouter from './App.router';

function App() {
  return (
    <AppRouter />
  );
}

export default App;
